import React from 'react';
import courses from './CourseData';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

function Courses() {
  return (
    <>
      <Header />
      <div className="page-container">
        <h2 className="section-title">Life-Long Learning</h2>
        <p className="section-description">
          Explore practical, real-world courses created by Abdulrahman Alamoudi.
        </p>

        <div className="course-grid">
          {courses.map((course) => (
            <div key={course.slug} className="course-card revealable">
              <h3 className="card-title">{course.title}</h3>
              <p className="card-text">{course.description}</p>

              {course.comingSoon ? (
                <span className="btn-disabled">Coming Soon</span>
              ) : (
                <Link to={`/courses/${course.slug}`} className="btn-primary">View Course</Link>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Courses;